export default {
  existing_documents: {
    description:
      'Vous avez déjà téléversé les documents suivants. Sélectionnez-en un et appuyez sur Envoyer, ou téléversez un nouveau document.',
    sides: {
      front: 'Recto',
      back: 'Verso',
    },
    created_at: 'Téléversé : {{date}}',
    expires_at: 'Expire : {{date}}',
  },
  document_types: {
    owner_document: "Pièce d'identité du propriétaire",
    business_document: 'Document professionnel',
  },
  form: {
    document_type: {
      label: "Justificatif d'entreprise",
      placeholder: 'Sélectionner le type de document',
      options: {
        vat_registration: 'Enregistrement TVA',
        trade_registration: 'Inscription au registre du commerce',
        trade_license: 'Licence commerciale',
        commercial_register_extract: 'Extrait du registre du commerce',
        financial_statements: 'États financiers',
        other: 'Autre',
      },
    },
    front: {
      label: 'Recto du document',
    },
    back: {
      label: 'Verso du document (facultatif pour certains documents)',
    },
    expires_at: {
      label: "Date d'expiration du document",
      placeholder: "Sélectionner la date d'expiration",
    },
  },
  buttons: {
    select_file: 'Sélectionner un fichier',
    next: 'Suivant',
    back: 'Verso',
    send: 'Envoyer',
    upload_new: 'Téléverser un nouveau document',
    use_existing: 'Utiliser un document téléversé',
  },
};
